/* eslint-disable */
import { mapGetters } from 'vuex'

import { Loader } from '@googlemaps/js-api-loader'
import { MarkerClusterer } from "@googlemaps/markerclusterer";

import ozBaseAmenities from '@/components/oz-base-amenities'
import ozCardPrices from '@/components/oz-card/oz-card-prices'

// tracking (map, ranking & lead)
import leadsTracker from '@/utils/tracking/lead/lead-panel-clicked'
import rankingClickedEvent from '@/utils/tracking/results/ranking-clicked'
import mapSearchClickedEvent from '@/utils/tracking/results/map-search-clicked'
import { modal } from '@/utils/constants/tracking/results/lead-clicked'

// GOOGLE MAPS CONFIG
const CONFIG = {
  apiKey: 'AIzaSyBIfq984Sof32yQQ-gyDIAOIs5CTkHIg40',
  version: 'weekly',
  libraries: ['places', 'visualization'],
}

let Popup

export default {
  name: 'oz-map-search',

  props: {
    active: Boolean,
    context: String,
    locations: {
      type: Array,
      default: () => [],
    },
    isLeadPhoneModalVariation: Boolean,
  },

  data () {
    return {
      map: null,
      activeMarker: null
    }
  },

  computed: {
    ...mapGetters('map', ['getPopup', 'getPopupImage', 'getPopupLink', 'getPopupAddress']),

    locationsCount () {
      return this.locations.length
    },

    contactText () {
      return 'Mensagem'
    },

    contactColor () {
      return 'cta'
    },
  },

  watch: {
    active (val) {
      if (!val && this.popup) {
        this.popup.hide()
        this.$store.dispatch('map/setPopup', {})
      }

      mapSearchClickedEvent.active(val ? 'ACTIVATED' : 'DEACTIVATED')
    },

    locationsCount () {
      if (this.map) {
        this.setMarkers()
      }
    },
  },

  methods: {
    init () {
      if (this.map) return

      // loader
      new Loader(CONFIG).load().then(() => {
        const { popup, map } = this.$refs || {}

        // set map
        this.map = new google.maps.Map(map, {
          disableDefaultUI: true,
          gestureHandling: 'greedy',
          center: { lat: -23.5505199, lng: -46.6333094 },
          zoom: 14,
        })

        // map bounds
        this.bounds = new google.maps.LatLngBounds()

        // popup
        if (popup) {
          this.setPopup()
          // popup
          this.popup = new Popup(this.map.getCenter(), popup)
          this.popup.setMap(this.map)
        }

        // set markers
        this.setMarkers()

        // set listeners
        this.map.addListener('click', () => {
          if(this.activeMarker?.id){
            this.resetMarkerLabel()
          }
          this.popup.hide()
          this.$store.dispatch('map/setPopup', {})

          // emit event
          this.$emit('map:events', 'MAP_CLICKED')
        })
      })
    },

    panToMarker (marker, id, event) {

      if (marker) {
        this.popup.hide()
        const pos = marker.getPosition()

        this.map.setCenter(pos)
        this.map.panBy(0, -200)

        this.$store.dispatch('map/setPopup', marker.info)

        this.popup.setPosition(pos)
        this.popup.show()

        if (event) {
          mapSearchClickedEvent.events(event, { listingId: id })

          // emit event
          this.$emit('map:events', event, marker)
        }
      }
    },

    setPopup () {
      Popup = class Popup extends google.maps.OverlayView {
        position
        popup
        constructor(position, popup) {
          super()
          this.position = position
          this.popup = popup
        }
        /**
         * onAdd is called when the map's panes are ready and the overlay has been
         * added to the map.
         */
        onAdd() {
          this.wrapper = document.createElement('div')
          this.wrapper.classList.add('popup-wrapper')
          this.wrapper.style.visibility = 'visible'
          this.wrapper.style.position = 'absolute'
          this.wrapper.appendChild(this.popup)

          this.getPanes().floatPane.appendChild(this.wrapper)
          Popup.preventMapHitsAndGesturesFrom(this.wrapper)
        }

        /**
         * The onRemove() method will be called automatically from the API if
         * we ever set the overlay's map property to 'null'.
         */
        onRemove() {
          if (this.wrapper) {
            this.wrapper.parentNode.removeChild(this.wrapper)
            delete this.wrapper;
          }
        }

        draw() {
          // We use the south-west and north-east
          // coordinates of the overlay to peg it to the correct position and size.
          // To do this, we need to retrieve the projection from the overlay.
          const overlayProjection = this.getProjection()
          // Retrieve the south-west and north-east coordinates of this overlay
          // in LatLngs and convert them to pixel coordinates.
          // We'll use these coordinates to resize the div.
          const sw = overlayProjection.fromLatLngToDivPixel(this.position)
          const ne = overlayProjection.fromLatLngToDivPixel(this.position)

          // Resize the image's div to fit the indicated dimensions.
          if (this.wrapper) {
            this.wrapper.style.left = sw.x + 'px'
            this.wrapper.style.top = ne.y + 'px'
          }
        }

        hide() {
          if (this.wrapper) {
            this.wrapper.classList.remove('active')
          }
        }

        show() {
          if (this.wrapper) {
            setTimeout(() => {
               this.wrapper.classList.add('active')
            }, 500)
          }
        }

        setPosition (pos) {
          this.position = pos
        }
      }
    },

    setMarkers () {
      if (!this.map || !this.locations.length) return

      // clear markers
      if (this.markerCluster) {
        this.popup.hide()
        this.markerCluster.clearMarkers()
        this.bounds = new google.maps.LatLngBounds(null)
      }

      // set markers
      this.markers = this.locations.map((location) => {
        const {
          info,
          position,
          id,
          listingsCount
        } = location

        const { pricingInfo } = info.listing
        const { price } = pricingInfo.priceMap[this.context] || pricingInfo

        const text = price || 'Sob consulta'

        const marker = new google.maps.Marker({
          id,
          map: this.map,
          position,
          info,
          icon: {
            url: '/',
            scaledSize: {
              width: 80,
              height: 32,
            },
          },
          label: {
            text,
            color: 'white',
            className: 'marker-custom',
          },
        })

        // marker position
        this.bounds.extend(marker.position)

        // marker click
        marker.addListener('click', () => {
          const label = marker.getLabel();
          const totalListing = listingsCount - 1
          label.text = listingsCount > 1 ? `+${totalListing} anunciantes divulgando este imóvel` : label.text
          marker.setLabel(label);

          if (this.activeMarker?.id && this.activeMarker.id !== id) {
            this.resetMarkerLabel()
          }

          this.activeMarker = marker
          this.map.setZoom(18)
          this.panToMarker(marker, id, 'MARKER_CLICKED')
        })

        return marker
      })

      // set marker clusters
      const clusterIcon = window.btoa(`
        <svg fill="#6E0AD6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160">
          <circle cx="80" cy="80" opacity="1" r="30" />
        </svg>`)

      // set marker clusters
      this.markerCluster = new MarkerClusterer({
        map: this.map,
        markers: this.markers,
        renderer: {
          render: ({ count, position }) => new google.maps.Marker({
            icon: {
              url: `data:image/svg+xml;base64,${clusterIcon}`,
              scaledSize: new google.maps.Size(75, 75),
            },
            label: {
              text: String(count),
              color: 'white',
              fontSize: '12px',
            },
            position,
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
          })
        },
      })

      this.map.fitBounds(this.bounds)
      this.map.panToBounds(this.bounds)

      // set marker clusters event
      google.maps.event.addListener(this.markerCluster, 'click', (cluster) => {
        mapSearchClickedEvent.events('CLUSTER_CLICKED', { numberCluster: cluster.markers.length })
      })
    },

    popupLinkClick () {
      const { listing, account } = this.getPopup
      const { href } = this.getPopupLink

      // tracking
      rankingClickedEvent({
        action: 'MAP SEARCH SEE DETAILS POPUP',
        account,
        listing,
        listingPosition: 0,
        results: this.$store.state.results,
      })

      window.open(href, '_blank')
    },

    popupLeadClick () {
      const { listing, account: publisher } = this.getPopup

      // tracking
      leadsTracker.leadPanelClicked({
        action: 'OPEN',
        listingId: listing.id,
        subject: 'MAP SEARCH LISTING CARD POPUP',
        screen: 'MODAL FORM',
      })

      this.$store.commit('ui/modals/setLeadModal', {
        leadModal: {
          show: true,
          listing,
          publisher,
          listingId: listing.id,
          trackingData: modal.mapListingCard,
          leadPhoneModalTest: {
            isLeadPhoneModalVariation: this.isLeadPhoneModalVariation,
            isResultPage: true,
          },
        },
      })
    },

    getBounds () {
      return this.map.getBounds()
    },

    tracker () {
      return mapSearchClickedEvent
    },

    resetMarkerLabel () {
      const { pricingInfo } = this.activeMarker.info.listing
      const { price } = pricingInfo.priceMap[this.context] || pricingInfo
      this.activeMarker.label.text = price || 'Sob consulta'
      new google.maps.Marker(this.activeMarker)
    },
  },

  components: {
    ozCardPrices,
    ozBaseAmenities,
  },
}
